import { IAlert, IUIFeatureObjectModel } from "@/types";
import { ALERT_TYPE } from "@/constants/CommonWebCodes";
export const alertDefault: IAlert = {
  show: false,
  type: ALERT_TYPE.SUCCESS,
  dismissible: true,
  message: "Default Value",
  timeout: 6000,
  multiline: false,
  error: "",
  response: "",
};

export const uiFeatureDefaultModel: IUIFeatureObjectModel = {
  largeText: "",
  displayName: "",
  resourceCode: "",
  resourceDescription: "",
  childFeatures: [] as string[],
  children: [] as IUIFeatureObjectModel[],
};
